module.exports = __webpack_public_path__ + "img/1.bd5b5c6d.png";